import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const INVOICE: AppRouteRecordRaw = {
  path: '/invoice',
  name: 'invoice',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '发票管理',
    icon: 'icon-file',
    requiresAuth: true,
    order: 10,
  },
  children: [
    {
      path: 'list',
      name: 'InvoiceList',
      component: () => import('@/views/invoice/index.vue'),
      meta: {
        locale: '发票列表',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default INVOICE; 